/*!
 * network.js - network object for bcoin
 * Copyright (c) 2014-2015, Fedor Indutny (MIT License)
 * Copyright (c) 2014-2017, Christopher Jeffrey (MIT License).
 * https://github.com/bcoin-org/bcoin
 */
'use strict';

var _classCallCheck = require("/opt/build/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/opt/build/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

function _createForOfIteratorHelper(o, allowArrayLike) { var it; if (typeof Symbol === "undefined" || o[Symbol.iterator] == null) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = o[Symbol.iterator](); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

var assert = require('bsert');

var binary = require('../utils/binary');

var networks = require('./networks');

var consensus = require('./consensus');

var TimeData = require('./timedata');

var _require = require('../utils'),
    inspectSymbol = _require.inspectSymbol;
/**
 * Network
 * Represents a network.
 * @alias module:protocol.Network
 */


var Network = /*#__PURE__*/function () {
  /**
   * Create a network.
   * @constructor
   * @param {Object} options
   */
  function Network(options) {
    _classCallCheck(this, Network);

    assert(!Network[options.type], 'Cannot create two networks.');
    this.type = options.type;
    this.seeds = options.seeds;
    this.magic = options.magic;
    this.port = options.port;
    this.checkpointMap = options.checkpointMap;
    this.lastCheckpoint = options.lastCheckpoint;
    this.checkpoints = [];
    this.halvingInterval = options.halvingInterval;
    this.genesis = options.genesis;
    this.genesisBlock = options.genesisBlock;
    this.pow = options.pow;
    this.block = options.block;
    this.bip30 = options.bip30;
    this.activationThreshold = options.activationThreshold;
    this.minerWindow = options.minerWindow;
    this.deployments = options.deployments;
    this.deploys = options.deploys;
    this.unknownBits = ~consensus.VERSION_TOP_MASK;
    this.keyPrefix = options.keyPrefix;
    this.addressPrefix = options.addressPrefix;
    this.requireStandard = options.requireStandard;
    this.rpcPort = options.rpcPort;
    this.walletPort = options.walletPort;
    this.minRelay = options.minRelay;
    this.feeRate = options.feeRate;
    this.maxFeeRate = options.maxFeeRate;
    this.selfConnect = options.selfConnect;
    this.requestMempool = options.requestMempool;
    this.time = new TimeData();
    this.init();
  }
  /**
   * Get a deployment by bit index.
   * @param {Number} bit
   * @returns {Object}
   */


  _createClass(Network, [{
    key: "init",
    value: function init() {
      var bits = 0;

      var _iterator = _createForOfIteratorHelper(this.deploys),
          _step;

      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var deployment = _step.value;
          bits |= 1 << deployment.bit;
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }

      bits |= consensus.VERSION_TOP_MASK;
      this.unknownBits = ~bits >>> 0;

      for (var _i = 0, _Object$keys = Object.keys(this.checkpointMap); _i < _Object$keys.length; _i++) {
        var key = _Object$keys[_i];
        var hash = this.checkpointMap[key];
        var height = Number(key);
        this.checkpoints.push({
          hash: hash,
          height: height
        });
      }

      this.checkpoints.sort(cmpNode);
    }
    /**
     * Get a deployment by bit index.
     * @param {Number} bit
     * @returns {Object}
     */

  }, {
    key: "byBit",
    value: function byBit(bit) {
      var index = binary.search(this.deploys, bit, cmpBit);
      if (index === -1) return null;
      return this.deploys[index];
    }
    /**
     * Get network adjusted time.
     * @returns {Number}
     */

  }, {
    key: "now",
    value: function now() {
      return this.time.now();
    }
    /**
     * Get network adjusted time in milliseconds.
     * @returns {Number}
     */

  }, {
    key: "ms",
    value: function ms() {
      return this.time.ms();
    }
    /**
     * Create a network. Get existing network if possible.
     * @param {NetworkType|Object} options
     * @returns {Network}
     */

  }, {
    key: "toString",

    /**
     * Convert the network to a string.
     * @returns {String}
     */
    value: function toString() {
      return this.type;
    }
    /**
     * Inspect the network.
     * @returns {String}
     */

  }, {
    key: inspectSymbol,
    value: function value() {
      return "<Network: ".concat(this.type, ">");
    }
    /**
     * Test an object to see if it is a Network.
     * @param {Object} obj
     * @returns {Boolean}
     */

  }], [{
    key: "create",
    value: function create(options) {
      if (typeof options === 'string') options = networks[options];
      assert(options, 'Unknown network.');
      if (Network[options.type]) return Network[options.type];
      var network = new Network(options);
      Network[network.type] = network;
      if (!Network.primary) Network.primary = network;
      return network;
    }
    /**
     * Set the default network. This network will be used
     * if nothing is passed as the `network` option for
     * certain objects.
     * @param {NetworkType} type - Network type.
     * @returns {Network}
     */

  }, {
    key: "set",
    value: function set(type) {
      assert(typeof type === 'string', 'Bad network.');
      Network.primary = Network.get(type);
      Network.type = type;
      return Network.primary;
    }
    /**
     * Get a network with a string or a Network object.
     * @param {NetworkType|Network} type - Network type.
     * @returns {Network}
     */

  }, {
    key: "get",
    value: function get(type) {
      if (!type) {
        assert(Network.primary, 'No default network.');
        return Network.primary;
      }

      if (type instanceof Network) return type;
      if (typeof type === 'string') return Network.create(type);
      throw new Error('Unknown network.');
    }
    /**
     * Get a network with a string or a Network object.
     * @param {NetworkType|Network} type - Network type.
     * @returns {Network}
     */

  }, {
    key: "ensure",
    value: function ensure(type) {
      if (!type) {
        assert(Network.primary, 'No default network.');
        return Network.primary;
      }

      if (type instanceof Network) return type;

      if (typeof type === 'string') {
        if (networks[type]) return Network.create(type);
      }

      assert(Network.primary, 'No default network.');
      return Network.primary;
    }
    /**
     * Get a network by an associated comparator.
     * @private
     * @param {Object} value
     * @param {Function} compare
     * @param {Network|null} network
     * @param {String} name
     * @returns {Network}
     */

  }, {
    key: "by",
    value: function by(value, compare, network, name) {
      if (network) {
        network = Network.get(network);
        if (compare(network, value)) return network;
        throw new Error("Network mismatch for ".concat(name, "."));
      }

      var _iterator2 = _createForOfIteratorHelper(networks.types),
          _step2;

      try {
        for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
          var type = _step2.value;
          network = networks[type];
          if (compare(network, value)) return Network.get(type);
        }
      } catch (err) {
        _iterator2.e(err);
      } finally {
        _iterator2.f();
      }

      throw new Error("Network not found for ".concat(name, "."));
    }
    /**
     * Get a network by its magic number.
     * @param {Number} value
     * @param {Network?} network
     * @returns {Network}
     */

  }, {
    key: "fromMagic",
    value: function fromMagic(value, network) {
      return Network.by(value, cmpMagic, network, 'magic number');
    }
    /**
     * Get a network by its WIF prefix.
     * @param {Number} value
     * @param {Network?} network
     * @returns {Network}
     */

  }, {
    key: "fromWIF",
    value: function fromWIF(prefix, network) {
      return Network.by(prefix, cmpWIF, network, 'WIF');
    }
    /**
     * Get a network by its xpubkey prefix.
     * @param {Number} value
     * @param {Network?} network
     * @returns {Network}
     */

  }, {
    key: "fromPublic",
    value: function fromPublic(prefix, network) {
      return Network.by(prefix, cmpPub, network, 'xpubkey');
    }
    /**
     * Get a network by its xprivkey prefix.
     * @param {Number} value
     * @param {Network?} network
     * @returns {Network}
     */

  }, {
    key: "fromPrivate",
    value: function fromPrivate(prefix, network) {
      return Network.by(prefix, cmpPriv, network, 'xprivkey');
    }
    /**
     * Get a network by its xpubkey base58 prefix.
     * @param {String} prefix
     * @param {Network?} network
     * @returns {Network}
     */

  }, {
    key: "fromPublic58",
    value: function fromPublic58(prefix, network) {
      return Network.by(prefix, cmpPub58, network, 'xpubkey');
    }
    /**
     * Get a network by its xprivkey base58 prefix.
     * @param {String} prefix
     * @param {Network?} network
     * @returns {Network}
     */

  }, {
    key: "fromPrivate58",
    value: function fromPrivate58(prefix, network) {
      return Network.by(prefix, cmpPriv58, network, 'xprivkey');
    }
    /**
     * Get a network by its base58 address prefix.
     * @param {Number} value
     * @param {Network?} network
     * @returns {Network}
     */

  }, {
    key: "fromAddress",
    value: function fromAddress(prefix, network) {
      return Network.by(prefix, cmpAddress, network, 'base58 address');
    }
    /**
     * Get a network by its bech32 address prefix.
     * @param {String} hrp
     * @param {Network?} network
     * @returns {Network}
     */

  }, {
    key: "fromBech32",
    value: function fromBech32(hrp, network) {
      return Network.by(hrp, cmpBech32, network, 'bech32 address');
    }
  }, {
    key: "isNetwork",
    value: function isNetwork(obj) {
      return obj instanceof Network;
    }
  }]);

  return Network;
}();
/**
 * Default network.
 * @type {Network}
 */


Network.primary = null;
/**
 * Default network type.
 * @type {String}
 */

Network.type = null;
/*
 * Networks (to avoid hash table mode).
 */

Network.main = null;
Network.testnet = null;
Network.regtest = null;
Network.segnet4 = null;
Network.simnet = null;
/*
 * Set initial network.
 */

Network.set(process.env.BCOIN_NETWORK || 'main');
/*
 * Helpers
 */

function cmpBit(a, b) {
  return a.bit - b;
}

function cmpNode(a, b) {
  return a.height - b.height;
}

function cmpMagic(network, magic) {
  return network.magic === magic;
}

function cmpWIF(network, prefix) {
  return network.keyPrefix.privkey === prefix;
}

function cmpPub(network, prefix) {
  return network.keyPrefix.xpubkey === prefix;
}

function cmpPriv(network, prefix) {
  return network.keyPrefix.xprivkey === prefix;
}

function cmpPub58(network, prefix) {
  return network.keyPrefix.xpubkey58 === prefix;
}

function cmpPriv58(network, prefix) {
  return network.keyPrefix.xprivkey58 === prefix;
}

function cmpAddress(network, prefix) {
  var prefixes = network.addressPrefix;

  switch (prefix) {
    case prefixes.pubkeyhash:
    case prefixes.scripthash:
    case prefixes.scripthash2:
    case prefixes.witnesspubkeyhash:
    case prefixes.witnessscripthash:
      return true;
  }

  return false;
}

function cmpBech32(network, hrp) {
  return network.addressPrefix.bech32 === hrp;
}
/*
 * Expose
 */


module.exports = Network;